<div class="tutorial-content center-text cosmetic-presets">
  <div class="">
    <p>
      Change the Drop Tier label styles to make them stand out more.
      <br />Useful for faster-paced late-game content.
    </p>

    <h3>Label Colors</h3>
    <div class="tutorial-options">
      <div class="tutorial-option" [class.selected]="filter.cosmeticPresets.labelColor === 'default'" (click)="setLabelColor('default')">
        Default
      </div>

      <div class="tutorial-option" [class.selected]="filter.cosmeticPresets.labelColor === 'accentNeutral'" (click)="setLabelColor('accentNeutral')">
        Accent, Neutral
      </div>

      <div class="tutorial-option" [class.selected]="filter.cosmeticPresets.labelColor === 'accentTiered'" (click)="setLabelColor('accentTiered')">
        Accent, Tiered
      </div>
    </div>

    <h3>Label Sizes</h3>
    <div class="tutorial-options">
      <div class="tutorial-option" [class.selected]="filter.cosmeticPresets.labelSize === 'default'" (click)="setLabelSize('default')">
        Default
      </div>

      <div class="tutorial-option" [class.selected]="filter.cosmeticPresets.labelSize === 'larger'" (click)="setLabelSize('larger')">
        Larger
      </div>

      <div class="tutorial-option" [class.selected]="filter.cosmeticPresets.labelSize === 'veryLarge'" (click)="setLabelSize('veryLarge')">
        Increasing
      </div>
    </div>

    @if (showStartingTierSlider) {
      <h3>Starting Tier</h3>
      <div class="tutorial-options label-size-slider">
        <input type="range" min="0" max="3" [value]="startingTierIndex" (input)="onStartingTierChange($event)" />
        <span class="label-size-value">{{ startingTierLabel }}</span>
      </div>
    }

    <h3>Default Label Size</h3>
    <div class="tutorial-options label-size-slider">
      <input type="range" min="0" max="6" [value]="defaultLabelSizeIndex" (input)="onDefaultLabelSizeChange($event)" />
      <span class="label-size-value">{{ defaultLabelSizeLabel }}</span>
    </div>

    <app-rule-preview [scrollable]="false" class="cosmetic-preview" [rules]="currencyRules"></app-rule-preview>

    <app-rule-preview [scrollable]="false" class="cosmetic-preview" [rules]="uniqueRules"></app-rule-preview>

    <button type="button" class="btn apply-btn" (click)="cosmeticPresetsService.applyPreset(filter); updateFilter.emit(); closeDialog();">
      Apply
    </button>
  </div>
</div>
